export const MSW_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST— MEDICAL SOCIAL WORKER",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Knowledge of Assessment Process:",
                items: [
                    "a. Health and psychosocial history",
                    "b. Development of Problem List",
                    "c. Assists in the development of care plan",
                    "d. Assesses response to treatment",
                    "e. Establishes and revises goals",
                    "f. DC planning",
                    "g. Conducts complete initial evaluation",
                    "h. Other"
                ]
            },
            {
                category: "2. Documentation skills:",
                items: [
                    "a. 485, 486, 487",
                    "b. Progress notes, flow charts",
                    "c. Summary report",
                    "d. Incident/variance reporting",
                    "e. Other"
                ]
            },
            {
                category: "3. Adheres to POC",
                items: [
                    "a. Reviews POC prior to care",
                    "b. Performs services as ordered",
                    "c. Documents according to POC",
                    "d. Communicates/coordinates as appropriate",
                    "e. Other"
                ]
            }
        ]
    },

    // Page 2: Administrative Continued & Patient Education
    {
        id: 2,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate: (continued)",
        competencies: [
            {
                category: "4. Knowledge of Medicare/State Home Health guidelines:",
                items: [
                    "a. Criteria for participation",
                    "b. Skilled reimbursable visit",
                    "c. Other"
                ]
            },
            {
                category: "5. Reports and documents key information to Physician, DC planner, Clinician, Pharmacist, Supervisor"
            },
            {
                category: "6. Submits written summary reports as indicated"
            },
            {
                category: "7. Attends/participates in case conference as required"
            },
            {
                category: "8. Infection Control Practices:",
                items: [
                    "a. Hand washing",
                    "b. Personal protective equipment",
                    "c. Exposure control plan",
                    "d. Equipment care, as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "9. Patient home safety"
            },
            {
                category: "10. Other"
            },
            {
                category: "B. Patient Education:",
                items: [
                    "1. Determines learning needs",
                    "2. Sets objectives",
                    "3. Develops/implements teaching plan",
                    "4. Evaluates effectiveness of teaching",
                    "5. Revises teaching plan",
                    "6. Documents patient response",
                    "7. Other"
                ]
            }
        ]
    },

    // Page 3: Assessment and Evaluation
    {
        id: 3,
        type: 'section',
        title: "C. Assessment and Evaluation:",
        competencies: [
            {
                category: "C. Assessment and Evaluation:",
                items: [
                    "1. Psychosocial assessment (social Hx., living situation, career, hobbies, support systems, decision making, communication difficulties, flexibility, prolonged mental illness/emotional problems, lack of community/caregiver support, family discord, ability to deal with loss)",
                    "2. Financial assessment (income, ability to meet needs, management)",
                    "3. Emotional assessment (response to illness, status, need for care, response to treatment)",
                    "4. Spiritual assessment (beliefs, practices, religion, role in care)",
                    "5. Terminal care assessment: (ability to cope with death at home, patient/caregiver receptive to hospice, concurrent life crisis, active grieving process, dependent family members, assistance needed with bringing closure to life)",
                    "6. Other"
                ]
            }
        ]
    },

    // Page 4: Skilled Treatments/Interventions
    {
        id: 4,
        type: 'section',
        title: "D. Skilled Treatments/Interventions:",
        competencies: [
            {
                category: "D. Skilled Treatments/Interventions:",
                items: [
                    "1. Counseling for long range planning and decision making",
                    "2. Community resource planning and information",
                    "3. Short-term therapy related to illness",
                    "4. High risk intervention/patient safety risk",
                    "5. Arranges for long term care",
                    "6. Other interventions",
                    "7. Other"
                ]
            }
        ]
    },

    // Page 5: Comments & Signatures
    {
        id: 5,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Clinician Signature", name: "clinicianSignature" },
            { label: "Date", name: "clinicianDate", inputType: "date" },
            { label: "Evaluator Signature", name: "evaluatorSignature" },
            { label: "Date", name: "evaluatorDate", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 6,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const MSW_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Medical Social Worker",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The medical social worker is responsible for the implementation of standards of care for medical social work services."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Assesses the psychosocial status of patients related to the patient's illness and environment and communicates findings to the registered nurse.",
            "Carries out social evaluations and plans intervention based on evaluation findings.",
            "Maintains clinical records on all patients referred to social work.",
            "Provides information and referral services for Organization patients and families/caregivers regarding practical and environmental needs.",
            "Provides information to patients or families/caregivers and community agencies.",
            "Serves as liaison between patients or families/caregivers and community agencies.",
            "Maintains collaborative relationships with Organization personnel to support patient care.",
            "Maintains and develops contracts with public and private agencies as resources for patient and organization personnel.",
            "Participates in the development of the total plan of care and case conferences as required.",
            "Assists physician and other team members in understanding significant social and emotional factors related to health problems.",
            "Participates in discharge planning.",
            "Other duties as delegated by the Clinical Director/Supervisor."
        ],
        generalStatement: "The above statements are only meant to be a representative summary of the major duties and responsibilities performed by incumbents of this job. The incumbents may be requested to perform job related tasks other than those stated in this description."
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of a bachelor's program in social work accredited by the Council on Social Work Education.",
            "Minimum of one year's experience in health care.",
            "Experience in a home health care preferred.",
            "Demonstrates good verbal and written communication, and organization skills.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
